<template>
	<figure class="progress-figure">
		<div
			class="progress display-flex"
			role="progressbar"
			aria-label="progress meter"
			aria-valuemin="0"
			:aria-valuenow="props.progressPercent"
			aria-valuemax="100"
			:style="{ height: `${props.height}px` }"
		>
			<div :class="['progress-bar', progressBarClasses]" :style="{ width: `${props.progressPercent}%` }">
				<span
					v-if="isAnimated"
					:class="[
						'loading-animation',
						props.barClass,
						{
							'loading-animation--sheen': addSheenEffect
						}
					]"
				/>
			</div>
		</div>
		<figcaption
			v-if="$slots['left-side'] || $slots['right-side']"
			class="display-flex justify-content-space-between align-items-center mt-50"
		>
			<slot name="left-side" />
			<slot name="right-side" />
		</figcaption>
	</figure>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
	progressPercent: string;
	barClass: string;
	height?: string;
	isAnimated?: boolean;
	isRounded?: boolean;
	addSheenEffect?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	height: '4',
	isAnimated: false,
	isRounded: true,
	addSheenEffect: false
});

const progressBarClasses = computed((): string => {
	let classes = '';
	if (props.isRounded) {
		classes = `${classes} rounded-left rounded-right`;
	}
	if (props.isAnimated) {
		classes = `${classes} bg-color-none`;
	} else {
		classes = `${classes} ${props.barClass}`;
	}
	return classes;
});
</script>
